import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { mostraAlerta } from "../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioIniciarSesion } from "../../configuracion/apiUrls";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import ModalRegistroCliente from "./ModalRegistroClienteV2";
import { NegocioConfig } from "../../configuracion/Empresa";

const Login = () => {

  const [username, setUsername] = useState("invitado");
  const [password, setPassword] = useState("Invitado123.");
  const [showPassword, setShowPassword] = useState(false);
  const { setLogin } = useContextUsuario();

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      mostraAlerta("Complete los campos", "warning");
      return;
    }

    try {
      const response = await AxiosPublico.post(UsuarioIniciarSesion, {
        login: username,
        contrasena: password,
      });

      const { data } = response;

      if (!data.Usuario || !data.Token || !data.Usuario.empresa) {
        mostraAlerta("Credenciales inválidas o empresa no encontrada", "warning");
        return;
      }

      const { Usuario: usuario, Token: token } = data;
      const empresa = usuario.empresa;

      mostraAlerta(`Bienvenido(a) ${usuario.datoPersonales.nombreCompleto}`, "success");
      await setLogin({ usuario, token, empresa });

      console.log("usuario", usuario);
      console.log("empresa", empresa);

      if (usuario.tipo === "Cliente") {
        navigate("/app/clientes/");
      } else if (usuario.tipo === "Empleado") {
        const accesoActivo = (usuario.accesos || []).find(a => a.estado === "Activo" && a.ruta ==="/app/admin/invernaderos/");
        if (accesoActivo) {
          console.log(accesoActivo);
          navigate(accesoActivo.ruta);
        } else {
          mostraAlerta("No tiene accesos activos asignados", "warning");
          //navigate("/app/admin/empleados/");
        }
      } else {
        navigate("/app/home");
      }

    } catch (error) {
      console.error("Error completo:", error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400 && Array.isArray(data)) {
          data.forEach((err) => {
            mostraAlerta(err.msg, "warning");
          });
        } else if (data && data.error) {
          mostraAlerta(data.error, "warning");
        } else {
          mostraAlerta("Error del servidor. Por favor, inténtalo de nuevo más tarde.", "warning");
        }
      } else if (error.request) {
        mostraAlerta("Error de conexión. Verifica tu conexión a internet.", "warning");
      } else {
        mostraAlerta("Error inesperado. Por favor, inténtalo de nuevo.", "warning");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="hold-transition login-page d-flex align-items-center" style={{ minHeight: "100vh" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0 rounded-lg mt-5">
              <div className="card-body p-0">
                <div className="row no-gutters">
                  {/* Contenedor del Logo - Visible en pantallas grandes */}
                  <div className="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center p-5 bg-primary text-white">
                    <div className="login-logo text-center">
                      <img
                        src={NegocioConfig.imagen}
                        alt="SIGAIN LOGO"
                        className="img-fluid rounded-circle"
                        style={{ width: "250px", height: "250px", marginBottom: "2rem" }}
                      />
                      <h1 className="h3 font-weight-bold">Bienvenido a SIGAIN</h1>
                      <p className="lead">Inicia sesión para gestionar tu invernadero.</p>
                    </div>
                  </div>
                  {/* Formulario de Login */}
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center mb-4 d-lg-none">
                        <img
                          src={NegocioConfig.imagen}
                          alt="SIGAIN LOGO"
                          className="img-fluid rounded-circle mb-3"
                          style={{ width: "150px", height: "150px" }}
                        />
                      </div>
                      <p className="login-box-msg h4 text-center">Inicio de sesión</p>
                      <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Nombre de usuario"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              autoComplete="username"
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span className="fas fa-user"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              placeholder="Contraseña"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              autoComplete="current-password"
                            />
                            <div className="input-group-append">
                              <div
                                className="input-group-text"
                                onClick={togglePasswordVisibility}
                                style={{ cursor: "pointer" }}
                              >
                                <span
                                  className={
                                    showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-grid gap-2 mt-4">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                          >
                            Iniciar Sesión
                          </button>
                        </div>
                      </form>
                      <div className="text-center mt-3 my-4">
                        <Link to="/recuperar-pin" className="forgot-password text-primary">
                          Olvidaste tu Contraseña
                        </Link>
                      </div>
                      {/* <div className="text-center mt-3">{<ModalRegistroCliente />}</div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
